import HttpClient from './HttpClient'

const ANON_SESSION_KEY = 'sw_anon_session'

/**
 * POST heartbeat de presencia (requiere auth).
 * @param {{ characterId?: number|null }} [opts]
 */
export async function postPresenceHeartbeat({ characterId = null } = {}) {
  const { data } = await HttpClient().post('/api/v1/presence/heartbeat', {
    characterId: characterId != null ? Number(characterId) : null,
  })
  return data
}

/**
 * POST heartbeat anónimo (visitantes sin personaje).
 * @param {{ sessionId?: string|null }} [opts]
 */
export async function postAnonPresenceHeartbeat({ sessionId = null } = {}) {
  const { data } = await HttpClient().post('/api/v1/presence/anon-heartbeat', {
    sessionId: sessionId || undefined,
  })
  const nextId = data?.sessionId || data?.data?.sessionId
  if (nextId && typeof localStorage !== 'undefined') {
    try {
      localStorage.setItem(ANON_SESSION_KEY, String(nextId))
    } catch {
      /* ignore */
    }
  }
  return data
}

export function getAnonSessionId() {
  if (typeof localStorage === 'undefined') return null
  try {
    return localStorage.getItem(ANON_SESSION_KEY)
  } catch {
    return null
  }
}

/**
 * GET lista de personajes online + contador anónimo.
 * @param {{ limit?: number, signal?: AbortSignal }} [opts]
 */
export async function fetchOnlinePresence({ limit = 500, signal } = {}) {
  const { data } = await HttpClient().get('/api/v1/presence/online', {
    params: { limit },
    signal,
  })
  if (data && Array.isArray(data.online)) {
    return {
      online: data.online,
      anonymousCount: Number(data.anonymousCount || 0),
      total: data.total,
      windowMinutes: data.windowMinutes,
    }
  }
  if (data?.data && Array.isArray(data.data.online)) {
    return {
      online: data.data.online,
      anonymousCount: Number(data.data.anonymousCount || 0),
      total: data.data.total,
      windowMinutes: data.data.windowMinutes,
    }
  }
  return { online: [], anonymousCount: 0, total: 0, windowMinutes: 10 }
}
